import React, { useState } from 'react';
import * as Yup from 'yup';
import {
  Box,
  Button,
} from '@chakra-ui/react';
import { InputText, Form } from '../../../components/form';
import { toast } from 'react-toastify';
import { fetchWrapper } from '../../../helpers';

function Create({ meClose, loadList }) {
  const [formData, setFormData] = useState({
    display_name: '',
    variable: '',
    description: '',
    required: false,
    type: '',
  });

  const FormSchema = Yup.object().shape({
    display_name: Yup.string().required('Display Name is required'),
    variable: Yup.string()
      .matches(/^\$\w+$/, 'Variable must start with $ and contain only letters, numbers, or underscores')
      .required('Variable is required'),
    // description: Yup.string().required(),
   
  });

  const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {
    let payload = {
      "display_name": values.display_name?.trim(),
      "variable": values.variable?.trim(),
      "description": values.description?.trim(),
      "required": true,
      "type": "String"
    }
    const url = `${process.env.REACT_APP_API_URL}/variables/create`;
    try {
      await fetchWrapper.post(url, payload);
      loadList();
      meClose();
      toast(`Variable has been added successfully`, {
        type: 'info',
      });
    } catch (error) {
      console.error('Error creating variable:', error);
      toast(`Failed to add variable`, {
        type: 'error',
      });
    }
  };





  return (
    <Form
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={formData}
      onSubmit={onSubmit}
    >
      <Box mb="10px">
        <InputText name="display_name" title="Display Name" placeholder="Display Name" inputProps={{ isRequired: true }} />
      </Box>

      <Box mb="10px">
        <InputText name="variable" title="Variable" placeholder="Variable (e.g., $example_variable)" inputProps={{ isRequired: true }} />
      </Box>

 
      <Box mb="10px">
        <InputText name="description" title="Description" inputProps={{ isRequired: false }} />
      </Box>

      <Button
        py="10px"
        px="25px"
        color="#fff"
        bg="#2563eb"
        fontSize="14px"
        fontWeight="500"
        fontFamily="'Open Sans', sans-serif"
        mb={4}
        type="submit"
      >
        Add New Variable
      </Button>
    </Form>
  );
}

export default Create;
